// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__ve7r6","unreadBadge":"styles_unreadBadge__3wpm9","modalContent":"styles_modalContent__nTUWp","modal":"styles_modal__1IvVn"};